import PriceISectionItemList, { PriceISectionItemListProps } from './PriceISectionItemList';

export type { PriceISectionItemListProps };
export default PriceISectionItemList;
